export const xs = 5
export const sm = 10
export const md = 15
export const lg = 30
